import { createFormSubmitGuard } from "src/decidim/volunteering/shared/form_submit_guard";
$(() => {
  const registrationForm = document.getElementById("new_offer_group_registration_");
  const volunteeringTypeGroup = document.getElementById("volunteering-type-group");
  const institutionNameInput = document.getElementById("offer_group_registration_institution_name");
  const institutionFormGroup = document.getElementById("institution-group");
  createFormSubmitGuard(registrationForm, { formActionsRoot: ".form-actions" });
  volunteeringTypeGroup.addEventListener("change", handleVolunteeringTypeRadioChange);
  function handleVolunteeringTypeRadioChange(event) {
    institutionNameInput.value = "";
    updateInstitutionNameInput(event.target);
  }
  function updateInstitutionNameInput(volunteeringTypeGroupInput) {
    if (!volunteeringTypeGroupInput) {
      return;
    }
    const required = !familyGroupsSelected(volunteeringTypeGroupInput);
    if (required) {
      institutionNameInput.setAttribute("required", "");
    } else {
      institutionNameInput.removeAttribute("required");
      $(registrationForm).foundation("validateInput", $(institutionNameInput));
    }
    institutionFormGroup.classList.toggle("hidden", !required);
    setRequiredLabelVisibility(institutionNameInput, required);
  }
  function setRequiredLabelVisibility(input, required) {
    const requiredIndicator = input.parentNode.querySelector(".label-required");
    if (!requiredIndicator) {
      return;
    }
    requiredIndicator.classList.toggle("hidden", !required);
  }
  function familyGroupsSelected(input) {
    return input.value === "family_groups";
  }
  updateInstitutionNameInput(volunteeringTypeGroup.querySelector('input[type="radio"]:checked'));
});
